export { default } from './star'
